const MobileAppOnlyDeepLinkURLPath = "/mobile-app/";

// Braze wraps every URL in every email it sends with SendGrid's click-tracking domain
// (ie, https://link.clicks.equip.health/ls/click?upn=<token>)
const EmailClickTrackingDomain = "link.clicks.equip.health";

// not every URL in a Braze email is a mobile-app link (eg: youtube, blog, etc)
// to distinguish which links should open the app, in Braze the tag 'universal="true"' is manually set per app link,
// which changes the URL's path from /ls/click -> /uni/ls/click
const EmailClickTrackingAppLinkPathPrefix = "/uni/";

export {
  EmailClickTrackingAppLinkPathPrefix,
  EmailClickTrackingDomain,
  MobileAppOnlyDeepLinkURLPath,
};
